import { render, staticRenderFns } from "./Setting_Logic.vue?vue&type=template&id=0920e68e&scoped=true"
import script from "./Setting_Logic.vue?vue&type=script&lang=js"
export * from "./Setting_Logic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0920e68e",
  null
  
)

export default component.exports